module.exports = __webpack_public_path__ + "img/shoteret_no.ecd7ee01.png";